import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=5994fdd9&scoped=true"
import script from "./aboutUs.vue?vue&type=script&lang=js"
export * from "./aboutUs.vue?vue&type=script&lang=js"
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=5994fdd9&prod&lang=scss"
import style1 from "./aboutUs.vue?vue&type=style&index=1&id=5994fdd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5994fdd9",
  null
  
)

export default component.exports